export class EInvoicePush{
    shifts?: any[];
}
